import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from '@nebula-shared/data-access';

@Injectable({ providedIn: 'root' })
export class TreasuryDateRangePickerServices extends BaseCrudService<any, any, any> {
  constructor() {
    super();
    this.setBaseUrl('/nebula-treasury/api/v1/parametros-tesoreria');
  }

  /**
   * Obtiene la fecha del sistema de tesorería
   */
  getSystemDate(): Observable<{ fechaSistema: string }> {
    return this.http.getContent<{ fechaSistema: string }>(`${this.baseUrl}/system-date`);
  }
}
